import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function ProBatLanding() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container product-landing probat-landing">
          <div className="section-header">
            <span className="section-badge">ProBat</span>
            <h1 className="product-title probat-title landing-product-title">
              <span>
                <span className="probat-title-text">ProBat</span>
                <span className="probat-title-copyright">©</span>
              </span>
            </h1>
            <p className="section-description landing-description">
              {translate("probatDescLong", language)}
            </p>
          </div>
          <div className="landing-cta">
            <a
              href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
                translate("probatTitle", language) +
                  " - " +
                  (language === "fr" ? "Contact" : "Contact")
              )}`}
              className="landing-link"
            >
              {translate("contactSupport", language)}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default ProBatLanding;
